module.exports = __webpack_public_path__ + "static/img/Soukëru Koor.988cb36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/codes/Soukëru Koor.png
// module id = qP9C
// module chunks = 1